<template>
    <el-dialog
        ref="fileShowDialog"
        top="8%"
        width="40%"
        class="file-show-dialog"
        v-loading="loading"
        :title="title"
        :before-close="handleClose"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
    >
        <div class="upload-file-list-container">
            <div v-if="fileList.length">
                <div
                    class="template_flex"
                    v-for="(item, index) in fileList"
                    :key="index"
                >
                    <div class="template_left">
                        <img src="@/assets/template.png" />
                        <div class="template">
                            <el-tooltip :content="item.name" placement="top">
                                <div class="upload-file-info">{{ item.name }}</div>
                            </el-tooltip>
                            <div>{{ item.fileSize }} KB</div>
                        </div>
                    </div>
                    <div class="template_float">
                        <i
                            class="el-icon-picture-outline modelBtn"
                            style="margin-right: 15px"
                            @click="handleView(item)"
                            v-if="videoShow.includes(item.type)"
                        ></i>
                        <i
                            class="el-icon-download modelBtn"
                            @click="handleDownload(item)"
                            v-else
                        ></i>
                    </div>
                </div>
            </div>
            <div v-else class="no-file-data">暂 无 附 件 数 据</div>
        </div>
        <imgShowDialog
            title="图片预览"
            :imgArr="currentRow"
            :attachmentShow.sync="attachmentShow"
            v-if="attachmentShow"
            @handleClose="closeDialog($event)"
        ></imgShowDialog>
    </el-dialog>
</template>
<script>
import * as api from '@otp/api/performanceTripartiteSettlement.js';
import { onlineFileView } from '@otp/api/performanceAbnormalBilling.js';
import imgShowDialog from './imgShow.vue';
export default {
    name: 'fileShowDialog',
    components: { imgShowDialog },
    props: {
        title: {
            type: String,
            default: '协议附件-查看'
        },
        dialogVisible: {
            type: Boolean,
            default: false
        },
        param: {
            typeof: Object,
            default () {
                return {};
            }
        },
        previewAble: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            loading: false,
            attachmentShow: false,
            currentRow: [],
            fileList: [],
            videoShow: ['png', 'jpg', 'jpeg'],
            previewShow: ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.pdf', '.txt']
        };
    },
    mounted () {
        this.initFileList();
    },
    methods: {
        initFileList () {
            this.loading = true;
            api.queryFiles(this.param).then(res => {
                if (res && +res.code === 0) {
                    this.fileList = res.data;
                }
            });
            this.loading = false;
        },
        handleView (item) {
            this.currentRow = [item];
            this.attachmentShow = true;
        },
        handlePreview(item) {
            if (!item.objId) return;
            onlineFileView({ id: item.objId }).then(res => {
                if (res && +res.code === 0) {
                    res.data && window.open(res.data);
                }
            }).catch(() => { });
        },
        handleDownload (item) {
            if (!item.path) {
                return this.$message.warning('获取文件下载地址失败，刷新页面重试');
            }
            window.location = item.path;
        },
        closeDialog (dialogName) {
            this[dialogName] = false;
        },
        handleClose () {
            this.$emit('handleClose', 'fileShowDialog');
        }
    }
};
</script>
<style lang="less">
@import url('../../style/fileShow.less');
</style>
